export enum BarrierPositionEnum {
        UnknownStopped,
        MovingToPos1Closed,
        MovingToPos2Open,
        AtPos1Closed,
        AtPos2Open
}